var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRegAboveTheFoldR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 80,
    viewBox: "0 0 140 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5154_54713)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 0.0195312H6.51163C2.91535 0.0195312 0 2.67266 0 5.94546V74.0936C0 77.3664 2.91535 80.0195 6.51163 80.0195H133.488C137.085 80.0195 140 77.3664 140 74.0936V5.94546C140 2.67266 137.085 0.0195312 133.488 0.0195312Z",
    fill: "#4F4C57"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5154_54713",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 128,
    height: 70
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 5.94531H6.51172V74.0935H133.488V5.94531Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5154_54713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.488 5.94531H6.51172V74.0935H133.488V5.94531Z",
    fill: "#4F4C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4187 5.94531H6.51172V74.0935H94.4187V5.94531Z",
    fill: "#625E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9304 23.7227H14.6513C13.7523 23.7227 13.0234 24.3859 13.0234 25.2041C13.0234 26.0223 13.7523 26.6856 14.6513 26.6856H30.9304C31.8295 26.6856 32.5583 26.0223 32.5583 25.2041C32.5583 24.3859 31.8295 23.7227 30.9304 23.7227Z",
    fill: "#908CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2793 29.6484H14.6513C13.7523 29.6484 13.0234 30.3117 13.0234 31.1299C13.0234 31.9481 13.7523 32.6114 14.6513 32.6114H86.2793C87.1783 32.6114 87.9072 31.9481 87.9072 31.1299C87.9072 30.3117 87.1783 29.6484 86.2793 29.6484Z",
    fill: "#908CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4188 38.5371H14.6513C13.7523 38.5371 13.0234 39.2004 13.0234 40.0186C13.0234 40.8368 13.7523 41.5001 14.6513 41.5001H24.4188C25.3179 41.5001 26.0467 40.8368 26.0467 40.0186C26.0467 39.2004 25.3179 38.5371 24.4188 38.5371Z",
    fill: "#908CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9112 65.2054H28.6637C30.1543 65.2054 30.9304 64.4951 30.9304 63.1381V55.4208C30.9304 54.0637 30.1543 53.3535 28.6637 53.3535H16.9112C15.4276 53.3535 14.6514 54.0574 14.6514 55.4208V63.1381C14.6514 64.4951 15.4276 65.2054 16.9112 65.2054ZM20.0228 59.3968C19.0817 59.3968 18.3056 58.6866 18.3056 57.8177C18.3056 56.9554 19.0817 56.2325 20.0228 56.2325C20.9569 56.2325 21.7263 56.9554 21.7263 57.8177C21.7263 58.6866 20.9569 59.3968 20.0228 59.3968ZM17.0211 63.9434C16.3961 63.9434 16.0182 63.5947 16.0182 63.0113V62.504L17.9553 60.944C18.2575 60.6967 18.5597 60.5763 18.8825 60.5763C19.2123 60.5763 19.5557 60.7031 19.8579 60.9503L21.1562 62.0347L24.4051 59.3714C24.7348 59.0987 25.1057 58.9719 25.4904 58.9719C25.8613 58.9719 26.2528 59.1051 26.5687 59.384L29.5566 61.9333V63.0176C29.5566 63.5947 29.1651 63.9434 28.5607 63.9434H17.0211Z",
    fill: "#908CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.489 5.94531H97.6748V74.0935H133.489V5.94531Z",
    fill: "#908CA0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5154_54713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 80,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegAboveTheFoldR);
export default __webpack_public_path__ + "static/media/icon-reg-above-the-fold-R.6a7b040e0b3ca6269488301e87101597.svg";
export { ForwardRef as ReactComponent };